import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    type: '',
    data: {
      input: '',
      id: null
    },
    disabled: false
  },
  mutations: {
    INIT_LOCATION_AND_MAP_ACTION_DIALOG(state) {
      state.visibility = true
    },
    SET_LOCATION_AND_MAP_ACTION_DIALOG_DISABLE_BTN(state, payload) {
      state.disabled = payload
    },
    SET_LOCATION_AND_MAP_ACTION_DIALOG_DATA(state, payload) {
      const { type, data } = payload
      state.type = type || null
      if (type === 'add_category') {
        state.data = data
      } else if (type === 'rename_category') {
        state.data = data
        state.data.input = data?.topic.category_name
      } else if (type === 'rename_map') {
        state.data = data
        state.data.input = data?.name
      }
    },
    RESET_LOCATION_AND_MAP_ACTION_DIALOG(state) {
      state.visibility = false

      state.type = null
      state.data.input = ''
    }
  },
  actions: {
    async initLocationAndMapActionDialog({ commit }, payload) {
      await commit('SET_LOCATION_AND_MAP_ACTION_DIALOG_DATA', payload)
      await commit('INIT_LOCATION_AND_MAP_ACTION_DIALOG')
    },

    async handleLocationAndMapActionDialog({ commit, rootState, dispatch }, payload) {
      const device_id = rootState.auth.selected_device
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''),
          loading: true
        })
        commit('SET_LOCATION_AND_MAP_ACTION_DIALOG_DISABLE_BTN', true)
        if (payload.data.type === 'add_category') {
          const response = await api.addCategoryLayer({ device_id: device_id, category: payload.data.input, parent_id: payload.data.dataForm.topic_layer.parent_id })
          if (response.data.success) {
            commit('ADD_CATEGORY_COLUMN_TOPIC_LAYER', { category_id: response.data.data.category_id, category_name: payload.data.input, index: payload.data.dataForm.layer_i })
            commit('SET_CATEGORY_COLUMN_TOPIC_LAYER_HAS_CHILD', { category_id: payload.data.dataForm.topic_layer.parent_id, has_child: true, index: payload.data.dataForm.layer_i - 1 })
            commit('SET_SNACKBAR', {
              status: true,
              color: 'success',
              text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''),
              icon: 'check',
              timeout: '2000'
            })
          }
        } else if (payload.data.type === 'rename_category') {
          const response = await api.updateCategoryLayer({ category_id: payload.data.dataForm.topic.category_id, params: { device_id: device_id, category: payload.data.input } })
          if (response.data.success) {
            commit('SET_SNACKBAR', {
              status: true,
              color: 'success',
              text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''),
              icon: 'check',
              timeout: '2000'
            })
            commit('UPDATE_CATEGORY_COLUMN_TOPIC_LAYER', { topic_index: payload.data.dataForm.topic_i, category_name: payload.data.input, index: payload.data.dataForm.layer_i })
          }
        } else if (payload.data.type === 'rename_map') {
          const response = await api.updateMap({ map_id: payload.data.dataForm.id, params: { device_id: device_id, name: payload.data.input } })
          if (response.data.success) {
            commit('SET_SNACKBAR', {
              status: true,
              color: 'success',
              text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''),
              icon: 'check',
              timeout: '2000'
            })
            dispatch('fetchMapList')
          }
        }
        commit('RESET_LOCATION_AND_MAP_ACTION_DIALOG')
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LOCATION_AND_MAP_ACTION_DIALOG_DISABLE_BTN', false)
      }
    }
  }
}
